import { render, staticRenderFns } from "./OpportunityActivities.vue?vue&type=template&id=4f362379&scoped=true&"
import script from "./OpportunityActivities.vue?vue&type=script&lang=js&"
export * from "./OpportunityActivities.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityActivities.vue?vue&type=style&index=0&id=4f362379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f362379",
  null
  
)

export default component.exports